import firebase from 'firebase';

class Backend {
    uid = '';
    ramp1Ref = null;
    ramp2Ref = null;
    ramp3Ref = null;
    ramp4Ref = null;

    // initialize Firebase Backend
    constructor() {
        firebase.initializeApp({
            apiKey: "AIzaSyAY1TM5QNuIsWXmLR-KlYzXpwSLmTqC4so",
            authDomain: "dizalica-e579e.firebaseapp.com",
            databaseURL: "https://dizalica-e579e.firebaseio.com",
            projectId: "dizalica-e579e",
            storageBucket: "dizalica-e579e.appspot.com",
            messagingSenderId: "847666380756"
        });

        // firebase.auth().onAuthStateChanged(user => {
        //     if (user) {
        //         //console.log(user);
        //         this.uid = user.uid;
        //     } else {

        //     }
        // });
        firebase.auth().signInAnonymously();
    }

    setUid = (value) => {
        this.uid = value;
    }

    getUid = () => {
        return this.uid;
    }

    raiseRamp1 = () => {
        if(!this.ramp1Ref) {
            this.ramp1Ref = firebase.database().ref('ramp1');
        }

        this.ramp1Ref.update({open: true});
    }

    raiseRamp2 = () => {
        if(!this.ramp2Ref) {
            this.ramp2Ref = firebase.database().ref('ramp2');
        }

        this.ramp2Ref.update({open: true});
    }

    raiseRamp3 = () => {
        if(!this.ramp3Ref) {
            this.ramp3Ref = firebase.database().ref('ramp3');
        }

        this.ramp3Ref.update({open: true});
    }

    raiseRamp4 = () => {
        if(!this.ramp4Ref) {
            this.ramp4Ref = firebase.database().ref('ramp4');
        }

        this.ramp4Ref.update({open: true});
    }

    // close the connection to the Backend
    close = () => {
        if (this.ramp1Ref) {
            this.ramp1Ref.off();
        }

        if (this.ramp2Ref) {
            this.ramp2Ref.off();
        }

        if (this.ramp3Ref) {
            this.ramp3Ref.off();
        }

        if (this.ramp4Ref) {
            this.ramp4Ref.off();
        }
    }

}

export default new Backend();